import { Component, EventEmitter, Output } from '@angular/core';
import { BaseRegulatorySectionComponent } from '../../../common/base-regulatory-section/base-regulatory-section.component';
import { RegepCompensationModel } from 'src/app/+regep/entities/enums/regepCompensationModel';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-models-feed-in-compensation',
  templateUrl: './models-feed-in-compensation.component.html',
  styleUrls: ['./models-feed-in-compensation.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ModelsFeedInCompensationComponent extends BaseRegulatorySectionComponent {
  public readonly COMPENSATION_MODELS = RegepCompensationModel;

  @Output() changeCommentText = new EventEmitter<string>();

  protected get sectionComment(): string {
    return this.regulatoryData.regulatory_data_sections_state?.models_for_feed_in_compensation_comment;
  }

  protected set sectionComment(value: string) {
    this.regulatoryData.regulatory_data_sections_state.models_for_feed_in_compensation_comment = value;
  }

  protected get sectionLocked(): boolean {
    return this.regulatoryData.regulatory_data_sections_state?.is_models_for_feed_in_compensation_locked;
  }

  protected set sectionLocked(value: boolean) {
    this.regulatoryData.regulatory_data_sections_state.is_models_for_feed_in_compensation_locked = value;
  }
}
